export default __webpack_public_path__ + "static/media/watch.d41831f0.jpeg";